import { useEffect, useState } from "react";
import { FaSpinner } from "react-icons/fa";
import Pagination from "../components/common/Pagination";
import { hideModal, showModal } from "../utils/modalUtility";
import useAxios from "../utils/useAxios";
import DataTable from "../components/common/DataTable";

const Loation = () => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [location, setLocation] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const axiosAPI = useAxios();

  const [formData, setFormData] = useState({
    name: "",
  });

  function removeFormData() {
    setFormData({
      name: "",
    });
  }
  const handleChange = (e) => {
    const { id, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  async function fetchLocation() {
    try {
      setLoading(true);
      const response = await axiosAPI.get(`/api/location/?page=${page}`);
      setLocation(response?.data?.data);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      // Always turn off loading, whether success or error
      setLoading(false);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading

    const payload = {
      name: formData.name,
    };

    // console.log("Payload to ", payload);

    // setLoading(false);

    // return;

    try {
      let response;

      if (isEditMode) {
        response = await axiosAPI.put(
          `/api/location/${currentProjectId}`,
          payload,
        );

        window.notifyMessage(
          "Success",
          "Location details updated successfully",
          "success",
        );
      } else {
        response = await axiosAPI.post(`/api/location`, payload);
        window.notifyMessage(
          "Success",
          "Location details added successfully",
          "success",
        );
      }
      setIsEditMode(false)
      hideModal("newUserModal");
      removeFormData();
      fetchLocation(); // refresh list
    } catch (error) {
      const errorMsg = error?.response?.data?.message || "There was an error!";
      window.notifyMessage("Error", errorMsg, "danger");
    } finally {
      setLoading(false); // Stop loading in all cases
    }
  };

  const openEditModal = async (locationId) => {
    setIsEditMode(true);
    setCurrentProjectId(locationId);
    showModal("newUserModal");

    const locationToEdit = location.find(
      (location) => location.id === locationId,
    );

    setFormData({
      name: locationToEdit.name || "",
    });
  };

  // console.log("FormData", formData);

  const handleDelete = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(`/api/location/${id}`);
      window.notifyMessage("Success", "Deleted successfully", "success");
      fetchLocation();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger",
      );
    }
  };

  function openBlogModal() {
    showModal("newUserModal");
  }

  const closeModal = () => {
    setIsEditMode(false);
    removeFormData();
    setCurrentProjectId(null);
  };

  useEffect(() => {
    fetchLocation();
  }, []);

  useEffect(() => {
    fetchLocation();
  }, [page]);

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex justify-content-end align-items-end flex-column flex-md-row">
          <div>
            <button
              type="button"
              className="btn btn-dark btn-round mb-4"
              onClick={() => openBlogModal()}
            >
              Add Location
            </button>
          </div>
        </div>

        <div
          className="modal fade"
          id="newUserModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  {isEditMode ? "Edit Location" : "Add Location"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  {/* Blog Title */}
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                      Name *
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      placeholder="Enter location name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="d-flex gap-2">
                    <button
                      type="button"
                      className="btn theme-secondary-button btn-sm btn-rounded"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      className="btn theme-button btn-sm btn-rounded"
                      disabled={loading}
                    >
                      {loading ? (
                        <FaSpinner className="spinner" spin />
                      ) : isEditMode ? (
                        "Update Location"
                      ) : (
                        "Add Location"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Blogs Table */}
        <DataTable
          title="All Locations"
          data={location}
          loading={loading}
          totalCount={location?.length}
          columns={["Sr no", "Title", "Action"]}
          renderRow={(location, index) => (
            <tr key={location.id}>
              <td>{index + 1}</td>
              <td>{location?.name}</td>
              <td>
                <button
                  className="btn btn-icon btn-round btn-dark btn-sm me-2"
                  onClick={() => openEditModal(location.id)}
                >
                  <i className="fas fa-edit"></i>
                </button>
                <button
                  className="btn btn-icon btn-round btn-danger btn-sm me-2"
                  onClick={() => handleDelete(location.id)}
                >
                  <i className="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          )}
        >
          <Pagination totalPages={totalPages} setPage={setPage} page={page} />
        </DataTable>
      </div>
    </div>
  );
};

export default Loation;
